import { render, staticRenderFns } from "./FormOrderPreparationDetail.vue?vue&type=template&id=32a717de&scoped=true&"
import script from "./FormOrderPreparationDetail.vue?vue&type=script&lang=ts&"
export * from "./FormOrderPreparationDetail.vue?vue&type=script&lang=ts&"
import style0 from "./FormOrderPreparationDetail.vue?vue&type=style&index=0&id=32a717de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a717de",
  null
  
)

export default component.exports